import queryString from 'query-string';

import apiClient from '@/utils/feathersClient';

import { setAuthData, resetAuthData, setUser } from '@/store/user';

import type { PromiseThunk } from '@/types/store/common';
import type { User } from '@/types/global';

export const initAuth = (): PromiseThunk => async dispatch => {
  const parsedQuery = queryString.parse(window.location.search);

  if (parsedQuery.token) {
    localStorage.setItem('userToken', parsedQuery.token as string);
  }

  try {
    const { accessToken, user: currentUser } = await apiClient.reAuthenticate();

    dispatch(
      setAuthData({
        isAuth: true,
        isLoading: false,
        token: accessToken,
        user: currentUser,
      })
    );
  } catch {
    dispatch(
      setAuthData({
        isAuth: false,
        isLoading: false,
        token: null,
        user: null,
      })
    );
  }
};

export const logIn = (values: { email: string; password: string }): PromiseThunk => async dispatch => {
  dispatch(
    setAuthData({
      isAuth: false,
      isLoading: false,
      token: null,
      user: null,
    })
  )

  const { accessToken, user: currentUser } = await apiClient.authenticate({
    email: values.email,
    password: values.password,
    strategy: 'local',
  });

  dispatch(
    setAuthData({
      isAuth: true,
      isLoading: false,
      token: accessToken,
      user: currentUser,
    })
  );
};

export const logOut = (): PromiseThunk<any> => async dispatch => {
  await apiClient.logout();
  dispatch(resetAuthData());
};

export const patchUser = (values: Partial<User>): PromiseThunk<User> => async (dispatch, getState) => {
  const userId = getState().authUser.user._id;

  const response: User = await apiClient.service('users').patch(userId, values);
  dispatch(setUser(response));

  return response;
};
